import { isConnectorId, type ConnectorId } from "@whitehaven/contracts";

export const ADMIN_SETTINGS_PATH = "/admin/settings" as const;
export const ADMIN_CONNECTORS_PATH = "/admin/settings/connectors" as const;
export const ADMIN_INTEGRATIONS_COMPATIBILITY_PATH =
  "/admin/integrations" as const;
export const ADMIN_AUTH_SETTINGS_COMPATIBILITY_PATH =
  "/admin/settings/auth" as const;

export type AdminConnectorSettingsRoute =
  | {
      readonly kind: "overview" | "registry";
      readonly compatibility: "integrations" | null;
    }
  | {
      readonly kind: "detail";
      readonly connectorId: ConnectorId;
      readonly compatibility: "auth" | null;
    }
  | { readonly kind: "invalid"; readonly compatibility: null };

export function resolveAdminConnectorSettingsRoute(
  pathname: string,
): AdminConnectorSettingsRoute | null {
  if (pathname === ADMIN_SETTINGS_PATH) {
    return { kind: "overview", compatibility: null };
  }
  if (pathname === ADMIN_CONNECTORS_PATH) {
    return { kind: "registry", compatibility: null };
  }
  if (pathname === ADMIN_INTEGRATIONS_COMPATIBILITY_PATH) {
    return { kind: "registry", compatibility: "integrations" };
  }
  if (pathname === ADMIN_AUTH_SETTINGS_COMPATIBILITY_PATH) {
    return {
      kind: "detail",
      connectorId: "firebase",
      compatibility: "auth",
    };
  }

  const prefix = `${ADMIN_CONNECTORS_PATH}/`;
  if (pathname.startsWith(prefix)) {
    const connectorId = pathname.slice(prefix.length);
    return isConnectorId(connectorId)
      ? { kind: "detail", connectorId, compatibility: null }
      : { kind: "invalid", compatibility: null };
  }
  if (
    pathname.startsWith(`${ADMIN_SETTINGS_PATH}/`) ||
    pathname.startsWith(`${ADMIN_INTEGRATIONS_COMPATIBILITY_PATH}/`)
  ) {
    return { kind: "invalid", compatibility: null };
  }
  return null;
}
